import React from 'react';
import { Stethoscope, Zap, Building, Briefcase, Palette, Car, Home, Calculator } from 'lucide-react';
import './IndustrySelector.css';

const IndustrySelector = ({ selectedIndustry, onIndustryChange }) => {
  const industries = [
    {
      id: 'medical',
      name: 'Medical Practice',
      icon: Stethoscope,
      description: 'Primary Care & Specialty Medicine',
      color: '#10b981'
    },
    {
      id: 'dental',
      name: 'Dentistry',
      icon: Zap,
      description: 'Dental & Orthodontic Services',
      color: '#3b82f6'
    }
  ];

  return (
    <div className="industry-selector">
      <div className="selector-label">
        <span className="label-text">Select Your Healthcare Specialty</span>
        <span className="label-subtitle">Campaign templates will adapt to your practice type</span>
      </div>

      <div className="industry-grid">
        {industries.map((industry) => {
          const IconComponent = industry.icon;
          const isSelected = selectedIndustry === industry.id;

          return (
            <button
              key={industry.id}
              onClick={() => onIndustryChange(industry.id)}
              className={`industry-card ${isSelected ? 'selected' : ''}`}
            >
              <div className="industry-icon" style={{ backgroundColor: industry.color }}>
                <IconComponent className="icon" />
              </div>
              <div className="industry-info">
                <h3 className="industry-name">{industry.name}</h3>
                <p className="industry-description">{industry.description}</p>
              </div>
              <div className="industry-check">
                {isSelected && <span className="checkmark">✓</span>}
              </div>
            </button>
          );
        })}
      </div>

      {selectedIndustry && (
        <div className="selected-industry-indicator">
          <span className="indicator-text">
            Selected: <strong>{industries.find(i => i.id === selectedIndustry)?.name}</strong>
          </span>
        </div>
      )}
    </div>
  );
};

export default IndustrySelector;
